<template>
    <div style="width: 100%;height: 100vh;background-color: white;z-index: 999;position: fixed;top: 0;overflow-y: auto;"
         class="preview-window"
    >
        <v-container py-5 style="max-width: 800px;">

            <v-layout row wrap style="padding-top: 120px" class="pb-3">
                <a style="text-decoration: underline" @click="this.return">Назад к оформлению</a>
            </v-layout>

            <div class="container-wrapper">
                <v-layout row wrap class="preview-title" v-show="b2b">
                    <h1>Предварительный просмотр</h1>
                    <p >Пожалуйста, проверьте правильность введенных
                        данных:</p>
                </v-layout>

                <v-layout row wrap pt-3 class="preview-title" v-show="!b2b">
                    <h2>Эти данные будут в полисе. <br><u>Внимательно проверьте их!</u></h2>

                </v-layout>

                <h2 style="padding:24px 0">Условия страхования</h2>
                <v-layout row wrap>
                    <v-flex xs4 sm3 pt-0 pb-2>
                        <span class="preview-text-label">Срок</span><br>
                        {{ term === 12 ? '1 год' : term + ' мес' }}
                    </v-flex>
                    <v-flex xs8 sm3 pt-0 pb-2>
                        <span class="preview-text-label">Дата начала</span><br>
                        {{ dateStart.split('-').reverse().join('.') }}
                    </v-flex>
                </v-layout>

                <p style="padding: 30px 0">Цель использования авто: {{ previewUsagePurpose }}.
                    <br><span v-if="previewUsagePurpose.toLowerCase() !== 'такси'">В прокат и аренду не сдается, в качестве такси не используется.</span>
                </p>

                <h2 style="padding: 20px 0">Страхователь</h2>
                <p class="pb-4">{{ insurer.fio.surname }} {{ insurer.fio.name }} {{ insurer.fio.patronymic }}</p>

                <h2 style="padding: 20px 0">Собственник</h2>
                <p>{{ owner.fio.surname }} {{ owner.fio.name }} {{ owner.fio.patronymic }}</p>
                <v-layout row wrap>
                    <v-flex xs12 d-flex py-0>
                        <span class="preview-text-label">Адрес регистрации</span>
                    </v-flex>
                </v-layout>
                <v-layout row wrap pb-5>
                    <v-flex xs12 d-flex py-0>
                        {{owner.address.full }}
                        <!--
                        TODO по причине решения отключения валидации некоторых полей адреса мы не можем быть уверены, что он сохраниться верно. Поэтому выводим фул того, что сохранили
                        {{ owner.address.postalCode }}, {{ owner.address.region == owner.address.city ? owner.address.city : owner.address.city + ', ' + owner.address.region }},
                        {{ owner.address.street }}, {{ owner.address.house }}
                        {{ owner.address.flat ? ', кв ' + owner.address.flat : '' }} -->
                    </v-flex>
                </v-layout>

                <h2 style="padding: 20px 0">Транспортное средство</h2>
                <v-layout row wrap>
                    <v-flex xs12 sm6 md4 pt-0 pb-2>
                        <span class="preview-text-label">Марка / Модель</span><br>
                        {{ transport.mark }} {{ transport.model }}
                    </v-flex>
                    <v-flex xs12 sm6 md4 pt-0 pb-2>
                        <span class="preview-text-label">Гос номер</span><br>
                        {{ transport.licensePlate }}
                    </v-flex>
                </v-layout>
                <v-layout row wrap pt-0>
                    <v-flex xs12 sm6 md4 pt-0 pb-2>
                        <span class="preview-text-label">{{ carIdTypeName }}</span><br>
                        {{ transport[transport.idType] }}
                    </v-flex>
                    <v-flex xs12 sm6 md4 pt-0 pb-2>
                        <span class="preview-text-label">{{ carDocName }}</span>
                        <br>
                        {{ transport.carDoc.seriesNumber }}
                    </v-flex>
                </v-layout>

                <h2 style="padding-top: 70px">Водители</h2>
                <p class="pt-3 pb-5" v-if="drivers==='unlimited'">Количество допущенных водителей не ограничено</p>
                <v-container px-0 pb-2
                             v-for="(driver, key) in drivers"
                             :key="driver.n"
                             v-if="drivers!=='unlimited'">
                    <h3 style="padding: 16px 0">Водитель {{ driver.n}}</h3>
                    <p>{{ driver.fio.surname }} {{ driver.fio.name }} {{ driver.fio.patronymic }}</p>
                    <v-layout row wrap>
                        <v-flex xs12 sm4 md3 pt-0 pb-2 v-if="!driver.license.isInternationalDriverLicense">
                            <span class="preview-text-label">Водительские права</span><br>
                            {{ driver.license.seriesNumber }}
                        </v-flex>
                        <v-flex xs12 sm4 md3 pt-0 pb-2 v-if="driver.license.isInternationalDriverLicense">
                            <span class="preview-text-label">Водительские права</span><br>
                            {{ driver.license.internationalSeries + ' ' + driver.license.internationalNumber }}
                        </v-flex>
                        <v-flex xs12 sm4 md3 pt-0 pb-2 v-if="driver.license.isInternationalDriverLicense">
                            <span class="preview-text-label">Страна выдачи прав</span><br>
                            {{ driver.license.internationalCountryName }}
                        </v-flex>
                        <v-flex xs12 sm4 md3 pt-0 pb-2>
                            <span class="preview-text-label">Дата рождения</span><br>
                            {{ driver.birthday.split('-').reverse().join('.') }}
                        </v-flex>
                        <v-flex xs12 sm4 md3 pt-0 pb-2>
                            <span class="preview-text-label">Дата выдачи первых прав</span><br>
                            {{ driver.license.date.split('-').reverse().join('.') }}
                        </v-flex>
                        <v-flex xs12 sm4 md3 pt-0 pb-2 v-if="driver.license.oldSeriesNumber">
                            <span class="preview-text-label">Старые права</span><br>
                            {{ driver.license.oldSeriesNumber }}
                        </v-flex>
                    </v-layout>
                </v-container>
            </div>
            <!-- вот это можно вынести в отдельный компонент -->
            <v-container px-0 py-5>
                <v-layout pt-4 row wrap>
                    <v-flex xs12 sm6 md4>
                        <v-btn class="preview-button block"
                               @click="this.submit"
                               :loading="this.loading"
                        >Всё верно!
                        </v-btn>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                        <v-btn class="preview-button block"
                               style="color: black !important;
                                            background-color: white !important;
                                            border: solid 1px #c7c7c7;"
                               @click="this.return"
                        >Редактировать
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-container>
            <!-- ------ -->
            <v-layout row wrap style="padding-top: 120px">
            </v-layout>

        </v-container>
    </div>
</template>

<script>
    export default {
        name: 'Preview',
        props: ['preparedFormData', 'previewUsagePurpose', 'return', 'submit', 'b2b', 'loading'],

        data: function () {
            return this.preparedFormData;
        },

        computed: {
            carDocName() {
                switch (this.transport.carDoc.type) {
                    case 'srts': return 'СРТС'
                    case 'epts': return 'ЭПТС'
                    case 'pts':
                    default: return 'ПТС';
                }
            },
            carIdTypeName() {
                switch (this.transport.idType) {
                    case 'chassisNumber': return '№ Шасси'
                    case 'bodyNumber': return '№ Кузова'
                    case 'vin':
                    default: return 'VIN (Идентификационный номер)';
                }
            },
        },

    }
</script>

<style scoped>

    .preview-button {
        color: #ffffff !important;
        line-height: 1.45 !important;
        font-weight: 700 !important;
        font-size: 19px !important;
        text-transform: none !important;
        box-shadow: none !important;

        height: 70px;
        width: 90%;
        background-color: #00ba57 !important;;
        text-align: center;
        padding: 0 30px !important;

        border-width: 1px;
        border-radius: 100px;
        border-color: transparent;
        border-style: solid;
    }

    /deep/ .preview-text-label {
        color: #585858;
        font-size: 12px;
    }

    .preview-title h1{
        padding: 27px 0;
    }
    .preview-title p{
        font-size: 20px;
        padding: 5px 0
    }

    @media screen and (max-width: 650px){
        .preview-title h1{
            font-size: 32px;
        }
        .preview-title p{
            font-size: 18px;
        }
    }
</style>

<style scoped lang="scss">
.container-wrapper {
    background: #ffffff;
    border-radius: 14px;
    border: 1px solid #e9eceb;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.05);
    overflow: hidden;
    margin-bottom: 20px;
    padding: 20px;

    //.flex {
    //    padding: 10px;
    //}
}
</style>



// WEBPACK FOOTER //
// resources/js/components/fields/Preview.vue